import * as React from "react"
import { connect } from "react-redux"
import { XBlockProps } from "react-xmasonry"

import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"
import ContentWidgetBase from "../../common/grid/widgets/ContentWidgetBase"
import ContentWidgetListItem from "../../common/grid/widgets/ContentWidgetListItem"

import env from "../../../env"
import { Symbols } from "@tenforce/toolbox-fontmap"

const applicationPath = env.applicationPath

interface OwnProps extends XBlockProps {
    loadMoreLabel: string
    placeholderLabel: string
}

type StateProps = WorkspaceCoverPage.CoverPage

type Props = OwnProps & StateProps & DispatchProps

export class Content extends React.Component<Props> {
    render(): JSX.Element {
        const {
            content: {
                children,
                contentLabel,
                filter,
                hasMore,
                isLoading,
                noWorkspaceContentMessage,
            },
            loadMoreLabel,
            placeholderLabel,
        } = this.props

        return (
            <ContentWidgetBase
                filter={filter}
                hasMore={hasMore}
                isLoading={isLoading}
                loadMoreLabel={loadMoreLabel}
                noResults={noWorkspaceContentMessage}
                title={contentLabel}
                loadMore={this.loadMore}
                updateFilter={this.updateFilter}
                placeholder={placeholderLabel}
            >
                {children &&
                    children.map((child) => {
                        const isTutorial = child.Url.endsWith("tutorial")
                        const isSmartList = child.Url.endsWith("f")

                        let icon = Symbols.ListIcon

                        if (isTutorial) {
                            icon = Symbols.FileInfo
                        } else if (isSmartList) {
                            icon = Symbols.SmartlistIcon
                        }

                        return (
                            <ContentWidgetListItem
                                icon={icon}
                                key={child.Id}
                                title={child.Label}
                                url={`${applicationPath}${child.Url}`}
                            />
                        )
                    })}
            </ContentWidgetBase>
        )
    }

    loadMore = (): void => {
        const {
            content: { filter, offset, limit },
            requestWorkspaceContent,
        } = this.props
        requestWorkspaceContent(filter, offset + limit, limit)
    }

    updateFilter = (newFilter: string): void => {
        const {
            content: { filter, limit },
            requestWorkspaceContent,
        } = this.props

        if (newFilter !== filter) {
            requestWorkspaceContent(newFilter, 0, limit)
        }
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.workspaceCoverPage

export default connect(mapStateToProps, mapDispatchToProps)(Content)
